/** Asks the Getting started panel to re-read the owner's progress right away. */
export const OWNER_ONBOARDING_REFRESH_EVENT = 'owner-onboarding:refresh';

// The progress endpoints themselves must not trigger a refresh, or the panel would keep refreshing itself.
const IGNORED_URL_PARTS = ['/kiosk-registrations/me/', '/auth/'];

/**
 * Any successful change (save, copy link, submit...) can complete a checklist step on whichever page
 * the owner is on, so the panel is told to refresh straight after it. Reads never complete a step.
 */
export function notifyOwnerOnboardingMayHaveChanged(method: string | undefined, url: string | undefined): void {
  const verb = (method || 'get').toLowerCase();
  if (verb === 'get' || verb === 'head' || verb === 'options') return;
  if (url && IGNORED_URL_PARTS.some((part) => url.includes(part))) return;
  window.dispatchEvent(new CustomEvent(OWNER_ONBOARDING_REFRESH_EVENT));
}
